import { Box, Button, Card, CardContent, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import React from "react";

const FacilitatorHeader = ({ moveToNextTeam, startVoting, moveToNextCollectible, setViewGame, moveToNext }) => {

    const steps = {
        0: "Move to Disc",
        1: "Move to Cubits",
        2: "Move to Triangles",
        3: "Move to Ycelite",
        4: "Move to Gemeralds",
        5: "Move to Rozacron",
        6: "Move to StandardCredits",
        7: "Move to Bonuses"
    };
    
    

    return (
        <Card key="facilitatorHeader" sx={{
            mt: 1,
            mb: 1,
            mr: 2,
            ml: 2,
            height: "fit-content",
            background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.95) 0%, rgba(101, 67, 33, 0.92) 100%)',
            backdropFilter: 'blur(10px)',
            border: '0.2rem solid rgba(218, 165, 32, 0.7)',
            borderRadius: '1rem',
            boxShadow: '0 0.5rem 1.5rem rgba(0, 0, 0, 0.5), 0 0 1rem rgba(218, 165, 32, 0.4)',
        }} variant="outlined">
            <CardContent sx={{ pt: 2, paddingBottom: "16px!important" }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5" sx={{
                        fontFamily: "'Cinzel', serif",
                        color: '#FFD700',
                        fontWeight: 700,
                        textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                    }}>
                        Session Details
                    </Typography>
                    <Box display="flex" flexDirection="row" sx={{ float: "right" }}>
                        <FormControl sx={{
                            minWidth: 120,
                            mr: 2,
                            '& .MuiInputLabel-root': {
                                color: '#FFD700',
                            },
                            '& .MuiOutlinedInput-root': {
                                color: '#FFD700',
                                '& fieldset': {
                                    borderColor: 'rgba(218, 165, 32, 0.7)',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'rgba(255, 215, 0, 0.9)',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#FFD700',
                                },
                            },
                            '& .MuiSvgIcon-root': {
                                color: '#FFD700',
                            }
                        }}>
                            <InputLabel id="demo-simple-select-label">skip</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="skip"
                                onChange={(e) => moveToNext(Number(e.target.value))}
                            >
                                {Object.keys(steps).map((key) => (
                                    <MenuItem key={key} value={key}>{steps[key]}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Button variant="contained" sx={{
                            ml: 2,
                            fontFamily: "'Cinzel', serif",
                            fontWeight: 700,
                            background: 'linear-gradient(135deg, #DAA520 0%, #B8860B 100%)',
                            border: '0.125rem solid rgba(255, 215, 0, 0.6)',
                            borderRadius: '0.5rem',
                            boxShadow: '0 0.25rem 0.75rem rgba(218, 165, 32, 0.4)',
                            textTransform: 'uppercase',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #FFD700 0%, #DAA520 100%)',
                                boxShadow: '0 0.375rem 1rem rgba(218, 165, 32, 0.6)',
                            },
                        }} onClick={startVoting}>Start Voting</Button>
                        <Button variant="contained" sx={{
                            ml: 2,
                            fontFamily: "'Cinzel', serif",
                            fontWeight: 700,
                            background: 'linear-gradient(135deg, #DAA520 0%, #B8860B 100%)',
                            border: '0.125rem solid rgba(255, 215, 0, 0.6)',
                            borderRadius: '0.5rem',
                            boxShadow: '0 0.25rem 0.75rem rgba(218, 165, 32, 0.4)',
                            textTransform: 'uppercase',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #FFD700 0%, #DAA520 100%)',
                                boxShadow: '0 0.375rem 1rem rgba(218, 165, 32, 0.6)',
                            },
                        }} onClick={() => setViewGame(true)}>View Game</Button>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}

export default FacilitatorHeader;
